// api/workflowApi.js
import { fetchApi } from "../utils/apiUtils";

export const fetchWorkflowNodesApi = async (params) => {
  return fetchApi('task-list/', {
    method: 'POST',
    requiresAuth: true,
    body: params
  });
};

export const fetchWorkflowTilesApi = async (params, nextUrl = null) => {
  const url = nextUrl ?? 'workflow-library/';

  return fetchApi(url, {
    method: 'POST',
    requiresAuth: true,
    body: params
  });
};

export const fetchHelpPageApi = async (id) => {
  return fetchApi(`help-page/${id}/`, {
    method: 'GET',
    requiresAuth: true
  });
};

export const fetchTagsApi = async () => {
  return fetchApi('tag-list/', {
    method: 'GET',
    requiresAuth: true
  });
};

export const saveOrUpdateWorkflowApi = async (workflowData, workflowId) => {
  const endpoint = workflowId ? `edit-customer-workflow/${workflowId}/` : 'create-customer-workflow/';
  return fetchApi(endpoint, {
    method: 'POST',
    requiresAuth: true,
    body: workflowData
  });
};
export const TriggerWorkflowApi = async (workflowid) => {
  const endpoint = `trigger-workflow/`
  return fetchApi(endpoint, {
    method: 'POST',
    requiresAuth: true,
    body: { workflow_id: workflowid }
  });
}
export const ChangeWorkflowStatus = async (workflowid, status) => {
  try {
    const data = await fetchApi(`workflow_activate/`, {
      method: 'POST',
      requiresAuth: true,
      body: { active_status: status, id: Number(workflowid) }
    });

    return { status: 200, data };
  } catch (error) {
    return { status: error.status || 500, data: error.data || {} };
  }
};

export const fetchWorkflowTemplates = async (page, searchTerm, selectedFilterTags) => {
  const query = searchTerm || "";
  return fetchApi(`customer-workflow-list/?page=${page}`, {
    method: 'POST',
    requiresAuth: true,
    body: { name: query, tag_ids: selectedFilterTags }
  });
};

export const fetchWorkflowDataApi = async (id, type) => {
  const endpoint = (type === 'template' || type === 'workflow' || type === 'clone')
    ? `customer-workflow/${id}/`
    : `integration-or-workflow/${id}/`;

  return fetchApi(endpoint, {
    method: 'GET',
    requiresAuth: true
  });
};

export const fetchWorkflowSchedule = async (id) => {
  const response = await fetchApi(`schedule-workflow-list/${id}/`,
    {
      method: 'GET',
      requiresAuth: true
    }
  );
  return await response;
}

export const createWorkflowSchedule = async (payload) => {
  const response = await fetchApi(`schedule-workflow-create/`,
    {
      method: 'POST',
      requiresAuth: true,
      body: payload
    }
  );
  return await response;
}
export const updateWorkflowSchedule = async (payload) => {
  const response = await fetchApi(`schedule-workflow-date-update/`,
    {
      method: 'POST',
      requiresAuth: true,
      body: payload
    }
  );
  return await response;
}

export const activateWorkflowSchedule = async (payload) => {
  const response = await fetchApi(`schedule-workflow-activate/`,
    {
      method: 'POST',
      requiresAuth: true,
      body: payload
    }
  );
  return await response;
}

export const deleteWorkflow = async (workflowId) => {
  const response = await fetchApi(`customer-workflow-delete/${workflowId}/`,
    {
      method: 'GET',
      requiresAuth: true,
    }
  );
  return await response;
}

export const createWorkflowTeam = async (payload) => {
  const response = await fetchApi(`team/team-workflow-assign/`,
    {
      method: 'POST',
      requiresAuth: true,
      body: payload
    }
  );
  return await response;
}
export const fetchCustomTagsApi = async (nextPageUrl = null) => {
  // if nextPageUrl is null, start with page 1
  const url = nextPageUrl || "tag/custom-tag-list/?page=1";

  const response = await fetchApi(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: {},
    requiresAuth: true
  });

  return await response;
};


export const createWorkflowTag = async (payload) => {
  const response = await fetchApi(`tag/tag-workflow-assign/`,
    {
      method: 'POST',
      requiresAuth: true,
      body: payload
    }
  );
  return await response;
}


export const uploadFile = async (fileData) => {
  const response = await fetchApi(`workflow/config-file-upload/`, {
    method: 'POST',
    body: fileData, // Convert the data to JSON
    requiresAuth: true
  });
  return response;
}

export const viewUploadFile = async (fileID) => {
  const response = await fetchApi(`workflow/file-content-view/${fileID}`, {
    method: 'GET',
    requiresAuth: true
  });

  return response;
}